module.exports = __webpack_public_path__ + "static/img/news1.50017d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news1.png
// module id = sYGX
// module chunks = 1